(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5297],{

/***/ 36715:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/product-design",
      function () {
        return __webpack_require__(61059);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ product_design; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
;// CONCATENATED MODULE: ./styles/pages/styled/services/product-design.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 7.5rem;\n    padding-bottom: 9.125rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ed40nqt0"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";");
const JoinUsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ed40nqt1"
})(mixins/* defaultContainerSize */.sX, ";padding-top:4rem;padding-bottom:5rem;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");
const ProjectsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ed40nqt2"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.light_grey;
}, ";");

// EXTERNAL MODULE: ./components/sections/ProductDesign/Parallax/Parallax.tsx + 1 modules
var Parallax = __webpack_require__(23770);
// EXTERNAL MODULE: ./models/enums/titleAs.ts
var titleAs = __webpack_require__(79794);
;// CONCATENATED MODULE: ./pages/services/product-design.tsx







const DynamicWhatWeHaveBuilt = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4575), __webpack_require__.e(7930)]).then(__webpack_require__.bind(__webpack_require__, 94671)).then((mod)=>mod.WhatWeHaveBuilt), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(94671)
            ]
    }
});
const DynamicTestimonial = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4453).then(__webpack_require__.bind(__webpack_require__, 94453)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(94453)
            ]
    }
});
const DynamicLiveCollaboration = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9027).then(__webpack_require__.bind(__webpack_require__, 99027)).then((mod)=>mod.LiveCollaboration), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(99027)
            ]
    }
});
const DynamicOurProcess = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9637).then(__webpack_require__.bind(__webpack_require__, 29637)).then((mod)=>mod.OurProcess), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(29637)
            ]
    }
});
const DynamicProcessTimeline = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1939).then(__webpack_require__.bind(__webpack_require__, 11939)).then((mod)=>mod.ProcessTimeline), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(11939)
            ]
    }
});
const DynamicJoinUs = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8007).then(__webpack_require__.bind(__webpack_require__, 38007)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(38007)
            ]
    }
});
const DynamicProjects = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5871).then(__webpack_require__.bind(__webpack_require__, 45871)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(45871)
            ]
    }
});
const ProductDesign = (param)=>{
    let { data: { page  }  } = param;
    const sections = page.sections.map((section)=>({
            title: prismic_reactjs.RichText.asText(section.title),
            subtitle: prismic_reactjs.RichText.asText(section.subtitle),
            description: prismic_reactjs.RichText.asText(section.description),
            subDescription: prismic_reactjs.RichText.asText(section.sub_description),
            subtitleInfo: prismic_reactjs.RichText.asText(section.subtitle_info),
            image: section.image || {}
        }));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        className: "product-design",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Parallax/* Parallax */.V, {
                page: page,
                sections: sections,
                name: "product-design",
                backButtonColor: "white"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicWhatWeHaveBuilt, {
                id: "our-work",
                title: page.what_we_have_built_title,
                dribbble_text: page.dribbble_text,
                behance_text: page.behance_text,
                dribbble: page.dribbble,
                behance: page.behance,
                want_to_see_more: page.want_to_see_more_text,
                images: {
                    desktop: page.what_we_have_built_image_desktop,
                    tablet: page.what_we_have_built_image_tablet,
                    mobile: page.what_we_have_built_image_mobile
                },
                mobileImages: page.what_we_have_built_mobile,
                titleAs: "h3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicOurProcess, {
                id: "design-process",
                title: prismic_reactjs.RichText.asText(page.design_process_title),
                subtitle: page.design_process_subtitle,
                items: page.design_process_diagram,
                titleAs: titleAs/* TitleAs.h4 */.P.h4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicProcessTimeline, {
                    image: page.process_timeline_image
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicLiveCollaboration, {
                id: "collaboration",
                title: page.live_collaboration_title,
                text1: page.live_collaboration_text1,
                text2: page.live_collaboration_text2
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicTestimonial, {
                additionalClassName: "product-design__testimonial",
                title: prismic_reactjs.RichText.asText(page.what_is_like_to_title),
                quote: page.what_is_like_to_quote,
                caseName: prismic_reactjs.RichText.asText(page.what_is_like_to_person),
                casePosition: prismic_reactjs.RichText.asText(page.what_is_like_to_person_position),
                caseStudy: true,
                titleAs: titleAs/* TitleAs.h4 */.P.h4
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicProjects, {
                    items: page.projects,
                    title: prismic_reactjs.RichText.asText(page.projects_title),
                    description: page.projects_description,
                    titleAs: titleAs/* TitleAs.h5 */.P.h5
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JoinUsWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicJoinUs, {
                    id: "join-us",
                    title: prismic_reactjs.RichText.asText(page.join_us.title),
                    description: prismic_reactjs.RichText.asText(page.join_us.description),
                    actionLabel: prismic_reactjs.RichText.asText(page.join_us.action_label),
                    actionLink: page.join_us.action_link.url || "",
                    personImage: page.join_us.person_image,
                    personName: prismic_reactjs.RichText.asText(page.join_us.person_name),
                    personPosition: "Product Designer",
                    titleAs: titleAs/* TitleAs.h6 */.P.h6
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var product_design = (ProductDesign);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1880,9774,2888,179], function() { return __webpack_exec__(36715); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);